export const securitySetup = {
  junior: {
    requirements: [
      { name: 'Design Asset Security Training', description: 'Complete training on secure handling of UI design assets and brand materials', priority: 'high' },
      { name: 'Visual Asset Protection', description: 'Learn secure practices for handling visual assets and brand elements', priority: 'high' },
      { name: 'Design Tool Security', description: 'Secure configuration of UI design tools and cloud storage', priority: 'medium' },
      { name: 'Brand Compliance', description: 'Understand brand security guidelines and asset usage policies', priority: 'medium' }
    ],
    procedures: [
      { step: 'Complete design security training', command: 'Complete company UI design asset security and brand protection training' },
      { step: 'Set up secure asset storage', command: 'Configure secure cloud storage for design files with proper access controls' },
      { step: 'Enable 2FA on design tools', command: 'Enable two-factor authentication on all UI design platforms' },
      { step: 'Review asset sharing procedures', command: 'Understand secure design asset sharing and handoff procedures' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Advanced Design Security', description: 'Implement advanced security measures for UI design workflows', priority: 'high' },
      { name: 'Component Library Security', description: 'Ensure security of design system components and libraries', priority: 'high' },
      { name: 'Cross-platform Security', description: 'Maintain security across multiple design platforms and tools', priority: 'medium' },
      { name: 'Design Audit Compliance', description: 'Conduct regular security audits of UI design processes', priority: 'medium' }
    ],
    procedures: [
      { step: 'Implement design governance', command: 'Set up UI design governance framework with security controls' },
      { step: 'Secure component libraries', command: 'Implement security measures for design system components' },
      { step: 'Monitor design access', command: 'Set up monitoring for design asset access and modifications' },
      { step: 'Create security protocols', command: 'Develop security protocols for UI design workflows' }
    ]
  },
  senior: {
    requirements: [
      { name: 'UI Design Security Strategy', description: 'Define comprehensive security strategy for UI design operations', priority: 'high' },
      { name: 'Enterprise Design Governance', description: 'Establish enterprise-wide UI design governance and compliance', priority: 'high' },
      { name: 'Brand Asset Protection Framework', description: 'Implement comprehensive brand and visual asset protection', priority: 'high' },
      { name: 'Security Culture Development', description: 'Foster security-conscious culture within UI design teams', priority: 'medium' }
    ],
    procedures: [
      { step: 'Develop security framework', command: 'Create comprehensive security framework for UI design operations' },
      { step: 'Implement governance controls', command: 'Design and implement enterprise UI design governance controls' },
      { step: 'Establish compliance monitoring', command: 'Set up continuous compliance monitoring for design processes' },
      { step: 'Security awareness program', command: 'Develop security awareness and training program for UI design teams' }
    ]
  }
};
